import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../../elements-table/table';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';

const SpaceRentalTotalLineItem = ({spaceRentalTotal, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_price_table.space_rental_total"
        defaultMessage="Space rental total"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={spaceRentalTotal}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const AddonsTotalLineItem = ({addonsTotal, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_price_table.add_ons_total"
        defaultMessage="Add-ons total"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={addonsTotal}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const SubtotalTotalLineItem = ({subtotal, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_price_table.subtotal"
        defaultMessage="Subtotal"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={subtotal}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const ServiceFeeLineItem = ({fee, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage id='hosting.sales_tax_price_table.processing' defaultMessage='Processing' />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={fee}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const IncludedItemsLineItem = ({total, currency}) => (
  <div className="flex space-between table-row">
    <div className="flex-basis-50">
      <FormattedMessage id='hosting.sales_tax_price_table.included_items' defaultMessage='Included items' />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={total}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const TotalLineItem = ({total, currency}) => (
  <div className="flex space-between table-row heavy">
    <div className="flex-basis-50">
      <FormattedMessage
        id="hosting.sales_tax_price_table.total"
        defaultMessage="Total"
      />
    </div>
    <div className="flex-basis-50">
      <FormattedNumber
        value={total}
        currency={currency}
        style="currency"
      />
    </div>
  </div>
);

const PriceSalesTaxTableComponent = ({
  addOnsWithTaxTotal,
  spaceRentalTotal,
  subtotalWithTax,
  serviceFee,
  includedItemsWithTax,
  total,
  currency,
  intl
}) => {
  return (
    <div>
      <h4>
        <FormattedMessage id="hosting.sales_tax_price_table.price" defaultMessage="Price" />
      </h4>
      <Table
        tableHeaders={[{
          label: intl.formatMessage({ id: 'hosting.sales_tax_price_table.price', defaultMessage: 'Price' }),
          classname: 'flex-basis-10 text-transform-none'
        }]}
        tableBody={
          <div>
            {!!spaceRentalTotal && <SpaceRentalTotalLineItem spaceRentalTotal={spaceRentalTotal} currency={currency} />}

            {!!addOnsWithTaxTotal && <AddonsTotalLineItem addonsTotal={addOnsWithTaxTotal} currency={currency} />}

            {(!!spaceRentalTotal || !!addOnsWithTaxTotal) && <hr className="dotted margin-md-top margin-md-bottom" />}

            {!!subtotalWithTax && <SubtotalTotalLineItem subtotal={subtotalWithTax} currency={currency} />}

            {!!serviceFee && <ServiceFeeLineItem fee={serviceFee} currency={currency} />}

            {!!includedItemsWithTax && <IncludedItemsLineItem total={includedItemsWithTax} currency={currency} />}

            {(!!subtotalWithTax || !!serviceFee) && <hr className="dotted margin-md-top margin-md-bottom" />}

            <TotalLineItem total={total} currency={currency} />
          </div>
        }
      />
    </div>
  );
};

PriceSalesTaxTableComponent.propTypes = {
  addOnsWithTaxTotal: PropTypes.number,
  spaceRentalTotal: PropTypes.number,
  subtotalWithTax: PropTypes.number,
  serviceFee: PropTypes.number,
  includedItemsWithTax: PropTypes.number,
  total: PropTypes.number,
  currency: PropTypes.string,
  intl: intlShape
};

export const PriceSalesTaxTable = injectIntl(PriceSalesTaxTableComponent);
